import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useProfile } from '@/hooks/use-profile';

interface BulletinInspectionToolsProps {
  bulletin: any;
  isSelected: boolean;
}

const BulletinInspectionTools: React.FC<BulletinInspectionToolsProps> = ({
  bulletin,
  isSelected
}) => {
  const { user } = useAuth();
  const { profile } = useProfile(user?.id);

  // Only show inspection tools to admins when needed - keep minimal for live product
  if (!isSelected || !profile?.is_admin) {
    return null;
  }

  return null; // Removed all debugging UI for live product
};

export default BulletinInspectionTools;
